// import React, { useEffect, useRef, useState } from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import {
//   Bar,
//   Chart,
//   getElementsAtEvent,
//   getDatasetAtEvent,
//   getElementAtEvent,
// } from "react-chartjs-2";

// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import Swal from "sweetalert2";

// import { Button, Skeleton } from "@mui/material";
// import { common_axios } from "../../../App";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import moment from "moment";
// import { ModeComment } from "@mui/icons-material";
// import CancelImg from "../../../assets/images/cancel.png";
// import CancelIcon from "@mui/icons-material/Cancel";
// // import zoomPlugin from "chartjs-plugin-zoom";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
//   // zoomPlugin
// );

// export function MultiGraph({ value, api }) {
//   const history = useHistory();
//   const chartRef = useRef();
//   const resd = useSelector((data) => data?.dashboardReducer);
//   const [data, setData] = useState(null);
//   const [open, setOpen] = useState(true);
//   const assignUserApi = async (e) => {
//     if (value == "Daily") {
//       try {
//         setData([]);
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v2/get/message-send/or/message-deliver/bar-graph/day-wise`,
//           {
//             campaignRequest: {
//               startDateTime: `${resd?.timeSeries?.end}`,
//               endDateTime: `${resd?.timeSeries?.start}`,
//             },
//             role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//           }
//         );

//         if (res.data.statusDescription.statusCode == 200) {
//           // setData1(res.data);

//           if (res.data?.dataSets?.length == 0) {
//             setData([]);
//           } else {
//             let arrr = [];

//             for (let index = 0; index < res.data?.dataSets?.length; index++) {
//               let element = res.data?.dataSets?.[index];
//               if (res.data.dataSets[index].label == "Success") {
//                 res.data.dataSets[index]["backgroundColor"] = "#5ab778";
//                 res.data.dataSets[index]["borderColor"] = "#5ab778";
//                 res.data.dataSets[index]["icon"] = ThumbUpIcon;
//               }
//               if (res.data.dataSets[index].label == "Failed") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f ";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f ";
//                 res.data.dataSets[index]["icon"] = CancelIcon;
//               }
//               for (let i = 0; i < element?.data?.length; i++) {
//                 let element1 = element?.data?.[i];
//                 element["stack"] = `Stack ${index}`;
//                 // console.log({ element1 });
//                 if (element1 != null && element1 != 0) {
//                   arrr.push(element);
//                   break;
//                 }
//               }
//             }

          
//             if (arrr?.length > 0) {
//               setData({
//                 labels: res?.data?.xaxisLabelDate,
//                 labelsName: res?.data?.xaxisLabelDate,
//                 labelsNumber: res?.data?.xaxisLabels,
//                 datasets: arrr,
//               });
//             } else {
//               setData([]);
//             }

//             // let varrr0 = false;
//             // let varrr1 = false;
//             // for (let i = 0; i < res.data?.dataSets?.[0]?.data?.length; i++) {
//             //   if (res.data?.dataSets?.[0]?.data?.[i] != 0) {
//             //     varrr0 = true;
//             //   }
//             // }
//             // for (let i = 0; i < res.data?.dataSets?.[1]?.data?.length; i++) {
//             //   if (res.data?.dataSets?.[1]?.data?.[i] != 0) {
//             //     varrr1 = true;
//             //   }
//             // }

//             // let elementtt = [];

//             // if (varrr0) {
//             //   elementtt.push(res.data?.dataSets?.[0]);
//             // }

//             // if (varrr1) {
//             //   elementtt.push(elementtt.push(res.data?.dataSets?.[1]));
//             // }

//             // console.log({ varrr0, varrr1, elementtt }, elementtt?.length > 0);

//             // if ((varrr0 || varrr1) && elementtt?.length > 0) {
//             //   setData({
//             //     labels: res.data?.xaxisLabels,
//             //     datasets: res.data?.dataSets,
//             //   });
//             // }

//             setOpen(false);
//           }
//         } else {
//           setData([]);
//           setOpen(false);
//         }
//       } catch (error) {
//         setData([]);
//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } else {
//       try {
//         setData([]);
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/bar-graph/month-wise`,
//           {
//             campaignRequest: {
//               startDateTime: `${moment(resd?.timeSeries?.end).format(
//                 "YYYYMM"
//               )}`,
//               endDateTime: `${moment(resd?.timeSeries?.start).format(
//                 "YYYYMM"
//               )}`,
//             },
//             role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//           }
//         );

//         if (res.data.statusDescription.statusCode == 200) {
//           // setData1(res.data);

//           if (res.data?.dataSets?.length == 0) {
//             setData([]);
//           } else {
//             // let varrr0 = false;
//             // let varrr1 = false;

//             // for (let i = 0; i < res.data?.dataSets?.[0]?.data.length; i++) {
//             //   if (res.data?.dataSets?.[0]?.data?.[i] != 0) {
//             //     varrr0 = true;
//             //   }
//             // }
//             // for (let i = 0; i < res.data?.dataSets?.[1]?.data.length; i++) {
//             //   if (res.data?.dataSets?.[1]?.data?.[i] != 0) {
//             //     varrr1 = true;
//             //   }
//             // }

//             // let elementtt = [];

//             // if (varrr0) {
//             //   elementtt.push(res.data?.dataSets?.[0]);
//             // }

//             // if (varrr1) {
//             //   elementtt.push(elementtt.push(res.data?.dataSets?.[1]));
//             // }

//             // console.log({ varrr0, varrr1, elementtt }, elementtt.length > 0);

//             // if ((varrr0 || varrr1) && elementtt.length > 0) {
//             //   setData({
//             //     labels: res.data?.xaxixLabels,
//             //     datasets: elementtt,
//             //   });
//             // } else {
//             //   setData([]);
//             // }

//             let arrr = [];

//             for (let index = 0; index < res.data?.dataSets?.length; index++) {
//               let element = res.data?.dataSets?.[index];
//               if (res.data.dataSets[index].label == "Success") {
//                 res.data.dataSets[index]["backgroundColor"] = "#3f9143";
//                 res.data.dataSets[index]["borderColor"] = "#3f9143";
//                 res.data.dataSets[index]["icon"] = ThumbUpIcon;
//               }
//               if (res.data.dataSets[index].label == "Failed") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f ";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f ";
//                 res.data.dataSets[index]["icon"] = CancelIcon;
//               }
//               for (let i = 0; i < element?.data?.length; i++) {
//                 let element1 = element?.data?.[i];
//                 element["stack"] = `Stack ${index}`;

//                 if (element1 != null && element1 != 0) {
//                   arrr.push(element);
//                   break;
//                 }
//               }
//             }

//             if (arrr?.length > 0) {
//               setData({
//                 labels: res?.data?.xaxixLabels,
//                 datasets: arrr,
//               });
//             } else {
//               setData([]);
//             }

//             setOpen(false);
//           }
//         } else {
//           setData([]);
//           setOpen(false);
//         }
//       } catch (error) {
//         setData([]);
//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     }
//   };

//   const options = {
//     //   width: 839,
//     // plugins: {
//     //   title: {
//     //     display: true,
//     //     text: "User Management",
//     //     legend: {
//     //       position: "none",
//     //       display: false,
//     //     },
//     //   },

//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           title: (xDatapoint) => {
//             if (isNaN(xDatapoint?.[0].label)) {
//               return xDatapoint?.[0].label;
//             } else {
//               // console.log({ xDatapoint });
//               // var dateObj = new Date();
//               // var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
//               // var year = dateObj.getUTCFullYear();

//               // const newdate = xDatapoint?.[0].label + "/" + month1 + "/" + year;

//               // return newdate;

//               return data?.labelsName?.[xDatapoint?.[0]?.dataIndex];
//             }
//           },
//           // label: (yDatapoint) => {
//           //   console.log({ yDatapoint }); // All list shown in color
//           //   return "22";
//           // },
//         },
//       },
//       datalabels: {
//         display: true,
//         color: "transparent",
//         align: "center",
//         padding: {
//           right: 2,
//         },
//         labels: {
//           padding: { top: 10 },
//           title: {
//             font: {
//               weight: "bold",
//             },
//           },
//           value: {
//             color: "transparent",
//           },
//         },
//         formatter: function (value) {
//           return "\n" + value;
//         },
//       },
//     },

//     onHover: (event, activeElements) => {
//       // console.log({ activeElements });
//       if (activeElements?.length > 0) {
//         event.native.target.style.cursor = "pointer";
//       } else {
//         event.native.target.style.cursor = "auto";
//       }
//     },

//     hover: {
//       onHover: function (event, chartElement) {
//         event.native.target.style.cursor = chartElement[0]
//           ? "pointer"
//           : "default";
//         event.target.style.cursor = chartElement[0] ? "pointer" : "default";
//       },
//     },
//     //   // zoom: {
//     //   //   pan: {
//     //   //     enabled: true,
//     //   //     mode: "x",
//     //   //   },
//     //   //   // zoom: {
//     //   //   //   limits: {
//     //   //   //     y: { min: 0, max: 100 },
//     //   //   //     y2: { min: -5, max: 5 },
//     //   //   //   },
//     //   //   //   wheel: {
//     //   //   //     enabled: true,
//     //   //   //   },
//     //   //   //   pinch: {
//     //   //   //     enabled: true,
//     //   //   //   },

//     //   //   //   mode: "x",
//     //   //   // },
//     //   //   rangeMin: {
//     //   //     x: 2,
//     //   //     y: 1,
//     //   //   },
//     //   //   rangeMax: {
//     //   //     x: 10,
//     //   //     y: 150,
//     //   //   },
//     //   // },
//     // },
//     legend: {
//       display: false,
//     },
//     responsive: true,
//     interaction: {
//       mode: "index",
//       intersect: false,
//     },
//     scales: {
//       x: {
//         stacked: true,
//         maxTicksLimit: 11,
//         title: {
//           display: true,
//           text: `<---- ${value === "Daily" ? "Date" : "Month"} ---->`,
//           font: {
//             family: "Poppins, sans-serif",
//             size: 20,
//             weight: "bolder",
//             lineHeight: 1.2,
//           },
//         },
//       },
//       // y: {
//       //   stacked: true,
//       // },
//       y: {
//         ticks: {
//           min: 0,
//           max: 1,
//           stepSize: 1,
//           fontSize: 20,
//         },
//         title: {
//           display: true,
//           text: "<---- Count ---->",
//           // color: "#911",
//           font: {
//             family: "Poppins, sans-serif",
//             size: 20,
//             weight: "bolder",
//             lineHeight: 1.2,
//           },
//         },
//       },
//     },
//   };

//   // const options = {
//   //   scales: {
//   //     yAxes: [
//   //       {
//   //         ticks: {
//   //           min: 0,
//   //           max: 1,
//   //           stepSize: 20,
//   //           fontSize: 20,
//   //         },
//   //       },
//   //     ],
//   //     y: {
//   //       ticks: {
//   //         min: 0,
//   //         max: 1,
//   //         stepSize: 1,
//   //         fontSize: 20,
//   //       },
//   //     },
//   //   },
//   //   // elements: {
//   //   //   point: {
//   //   //     radius: 0
//   //   //   }
//   //   // }
//   // };

//   useEffect(() => {
//     assignUserApi();
//   }, [resd?.timeSeries?.start, resd?.timeSeries?.end, value]);

//   const printDatasetAtEvent = (dataset) => {
//     if (!dataset.length) return;

//     const datasetIndex = dataset[0].datasetIndex;

//     // console.log(data.datasets[datasetIndex].label);

//     return data.datasets[datasetIndex].label;
//   };

//   const printElementAtEvent = (element) => {
//     if (!element.length) return;

//     const { datasetIndex, index } = element[0];

//     // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
//     return data.labels[index];
//   };

//   const printElementIndexAtEvent = (element) => {
//     if (!element.length) return;

//     const { datasetIndex, index } = element[0];

//     return [index];
//   };

//   const printElementsAtEvent = (elements) => {
//     if (!elements.length) return;

//     // console.log(elements.length);
//     return elements.length;
//   };

//   const handleClick = (event) => {
//     // alert("Now clikced");

//     // console.log(
//     //   "IIIIIIII",
//     //   printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),
//     //   printElementAtEvent(getElementAtEvent(chartRef.current, event)),
//     //   printElementIndexAtEvent(getElementAtEvent(chartRef.current, event)),
//     //   !isNaN(
//     //     data?.labelsNumber?.[
//     //       printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
//     //     ]
//     //   )
//     // );

//     if (
//       // !isNaN(printElementAtEvent(getElementAtEvent(chartRef.current, event)))
//       !isNaN(
//         data?.labelsNumber?.[
//           printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
//         ]
//       )
//     ) {
//       var dateObj = new Date();
//       var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
//       var year = dateObj.getUTCFullYear();

//       const newdate =
//         year +
//         "-" +
//         month1 +
//         "-" +
//         printElementAtEvent(getElementAtEvent(chartRef.current, event));

//       if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
//         // localStorage?.setItem(
//         //   "dstQueCode1",
//         //   `${newdate},${printDatasetAtEvent(
//         //     getDatasetAtEvent(chartRef.current, event)
//         //   )},${value}`
//         // );
//         localStorage?.setItem(
//           "dstQueCode1",
//           `${
//             data?.labelsName?.[
//               printElementIndexAtEvent(
//                 getElementAtEvent(chartRef.current, event)
//               )
//             ]
//           },${printDatasetAtEvent(
//             getDatasetAtEvent(chartRef.current, event)
//           )},${value}`
//         );
//       } else {
//       }
//     } else {
//       // console.log(
//       //   "PPPPPP",

//       //   moment()
//       //     .month(
//       //       printElementAtEvent(getElementAtEvent(chartRef.current, event))
//       //     )
//       //     .format("M"),
//       //   moment().format("M"),
//       //   typeof moment().month("feb").format("M")
//       // );

//       if (
//         Number(
//           moment()
//             .month(
//               printElementAtEvent(getElementAtEvent(chartRef.current, event))
//             )
//             .format("M")
//         ) <= Number(moment().format("M"))
//       ) {
//         const endDate = moment(
//           moment().month(
//             printElementAtEvent(getElementAtEvent(chartRef.current, event))
//           )
//         )
//           .endOf("month")
//           .format("YYYY-MM-DD");
//         const startDate = moment(
//           moment().month(
//             printElementAtEvent(getElementAtEvent(chartRef.current, event))
//           )
//         )
//           .startOf("month")
//           .format("YYYY-MM-DD");
//         localStorage?.setItem(
//           "dstQueCode1",
//           `${startDate},${printDatasetAtEvent(
//             getDatasetAtEvent(chartRef.current, event)
//           )},${value},${endDate}`
//         );
//       } else {
//         const endDate = moment(
//           moment(
//             moment().month(
//               printElementAtEvent(getElementAtEvent(chartRef.current, event))
//             )
//           ).endOf("month")
//         )
//           .add(-1, "y")
//           .format("YYYY-MM-DD");
//         const startDate = moment(
//           moment(
//             moment().month(
//               printElementAtEvent(getElementAtEvent(chartRef.current, event))
//             )
//           ).startOf("month")
//         )
//           .add(-1, "y")
//           .format("YYYY-MM-DD");

//         localStorage?.setItem(
//           "dstQueCode1",
//           `${startDate},${printDatasetAtEvent(
//             getDatasetAtEvent(chartRef.current, event)
//           )},${value},${endDate}`
//         );
//       }
//     }
//     history?.push("/dashboard/Dashboardreport");
//     // printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event));
//     // printElementAtEvent(getElementAtEvent(chartRef.current, event));
//     // printElementsAtEvent(getElementsAtEvent(chartRef.current, event));
//   };

//   // <div className="table-responsive">

//   const handleButtonClick = (index) => {
//     // console.log(chartRef.current.data.dataset);
//     let dataaa = [...data?.datasets];
//     dataaa[index].clicked = !dataaa[index].clicked;
//     setData({
//       ...data,
//       datasets: dataaa,
//     });
//     chartRef.current.data.datasets[index].hidden =
//       !chartRef.current.data.datasets[index].hidden;
//     chartRef.current.update();
//   };
//   return (
//     <>
//       {!open && data ? (
//         <>
//           {data.length == 0 ? (
//             <div className="d-flex h-100 p-3">
//               <div className="m-auto text-center">
//                 <h1>No Data</h1>
//                 <img
//                   style={{ width: "100px", maxWidth: "100%" }}
//                   src={CancelImg}
//                   alt=""
//                   srcset=""
//                 />
//               </div>
//             </div>
//           ) : (
//             <>
//               <div className="d-flex justify-content-center mt-2">
//                 {data?.datasets?.map((dataaa, index) => {
//                   return (
//                     <div>
//                       {/* <button
//                         className="btn btn-primary me-2"
//                         style={{
//                           backgroundColor: dataaa.backgroundColor,
//                           textDecorationColor: "black",
//                           textDecoration: chartRef?.current?.data?.datasets?.[
//                             index
//                           ]?.hidden
//                             ? "line-through"
//                             : "none",
//                           color: "white",
//                         }}
//                         onClick={() => {
//                           handleButtonClick(index);
//                         }}
//                       >
//                         {dataaa?.label}
//                       </button> */}
//                       <Button
//                         className="me-3"
//                         size="small"
//                         sx={{
//                           borderRadius: 2,
//                           boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
//                           backgroundColor: chartRef?.current?.data?.datasets?.[
//                             index
//                           ]?.hidden
//                             ? "grey"
//                             : dataaa.backgroundColor,
//                           color: "white",
//                           textDecorationColor: "black",
//                           textDecoration: chartRef?.current?.data?.datasets?.[
//                             index
//                           ]?.hidden
//                             ? "line-through"
//                             : "none",
//                           color: "white",
//                         }}
//                         variant="contained"
//                         startIcon={
//                           dataaa.icon ? <dataaa.icon /> : <ThumbUpIcon  />
//                         }
//                         onClick={() => {
//                           handleButtonClick(index);
//                         }}
//                       >
//                         {dataaa?.label}
//                       </Button>


//                     </div>
//                   );
//                 })}
//               </div>
//               <Chart
//                 type="bar"
//                 ref={chartRef}
//                 options={options}
//                 data={data}
//                 onClick={handleClick}
//                 onHover={(event, chartElement) => {
//                   event.target.style.cursor = chartElement[0]
//                     ? "pointer"
//                     : "default";
//                 }}
//               />
//             </>
//           )}
//         </>
//       ) : (
//         <>
//           <Skeleton animation="wave" className="mt-3" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//         </>
//       )}
//     </>
//   );
//   // </div>
// }



import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Bar,
  Chart,
  getElementsAtEvent,
  getDatasetAtEvent,
  getElementAtEvent,
} from "react-chartjs-2";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import { Button, Skeleton } from "@mui/material";
import { common_axios } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { ModeComment } from "@mui/icons-material";
import CancelImg from "../../../assets/images/cancel.png";
import CancelIcon from "@mui/icons-material/Cancel";
// import zoomPlugin from "chartjs-plugin-zoom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
  // zoomPlugin
);

export function MultiGraph({ value, api }) {
  const history = useHistory();
  const chartRef = useRef();
  const resd = useSelector((data) => data?.dashboardReducer);
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  const assignUserApi = async (e) => {
    if (value == "Daily") {
      try {
        setData([]);
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v2/get/message-send/or/message-deliver/bar-graph/day-wise`,
          {
            campaignRequest: {
              startDateTime: `${resd?.timeSeries?.end}`,
              endDateTime: `${resd?.timeSeries?.start}`,
            },
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          // setData1(res.data);

          if (res.data?.dataSets?.length == 0) {
            setData([]);
          } else {
            let arrr = [];

            for (let index = 0; index < res.data?.dataSets?.length; index++) {
              let element = res.data?.dataSets?.[index];
              if (res.data.dataSets[index].label == "Success") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = ThumbUpIcon;
              }
              if (res.data.dataSets[index].label == "Failed") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f ";
                res.data.dataSets[index]["borderColor"] = "#f9442f ";
                res.data.dataSets[index]["icon"] = CancelIcon;
              }
              for (let i = 0; i < element?.data?.length; i++) {
                let element1 = element?.data?.[i];
                element["stack"] = `Stack ${index}`;
                // console.log({ element1 });
                if (element1 != null && element1 != 0) {
                  arrr.push(element);
                  break;
                }
              }
            }

          
            if (arrr?.length > 0) {
              setData({
                labels: res?.data?.xaxisLabelDate,
                labelsName: res?.data?.xaxisLabelDate,
                labelsNumber: res?.data?.xaxisLabels,
                datasets: arrr,
              });
            } else {
              setData([]);
            }

            // let varrr0 = false;
            // let varrr1 = false;
            // for (let i = 0; i < res.data?.dataSets?.[0]?.data?.length; i++) {
            //   if (res.data?.dataSets?.[0]?.data?.[i] != 0) {
            //     varrr0 = true;
            //   }
            // }
            // for (let i = 0; i < res.data?.dataSets?.[1]?.data?.length; i++) {
            //   if (res.data?.dataSets?.[1]?.data?.[i] != 0) {
            //     varrr1 = true;
            //   }
            // }

            // let elementtt = [];

            // if (varrr0) {
            //   elementtt.push(res.data?.dataSets?.[0]);
            // }

            // if (varrr1) {
            //   elementtt.push(elementtt.push(res.data?.dataSets?.[1]));
            // }

            // console.log({ varrr0, varrr1, elementtt }, elementtt?.length > 0);

            // if ((varrr0 || varrr1) && elementtt?.length > 0) {
            //   setData({
            //     labels: res.data?.xaxisLabels,
            //     datasets: res.data?.dataSets,
            //   });
            // }

            setOpen(false);
          }
        } else {
          setData([]);
          setOpen(false);
        }
      } catch (error) {
        setData([]);
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      try {
        setData([]);
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/bar-graph/month-wise`,
          {
            campaignRequest: {
              startDateTime: `${moment(resd?.timeSeries?.end).format(
                "YYYYMM"
              )}`,
              endDateTime: `${moment(resd?.timeSeries?.start).format(
                "YYYYMM"
              )}`,
            },
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          // setData1(res.data);

          if (res.data?.dataSets?.length == 0) {
            setData([]);
          } else {
            // let varrr0 = false;
            // let varrr1 = false;

            // for (let i = 0; i < res.data?.dataSets?.[0]?.data.length; i++) {
            //   if (res.data?.dataSets?.[0]?.data?.[i] != 0) {
            //     varrr0 = true;
            //   }
            // }
            // for (let i = 0; i < res.data?.dataSets?.[1]?.data.length; i++) {
            //   if (res.data?.dataSets?.[1]?.data?.[i] != 0) {
            //     varrr1 = true;
            //   }
            // }

            // let elementtt = [];

            // if (varrr0) {
            //   elementtt.push(res.data?.dataSets?.[0]);
            // }

            // if (varrr1) {
            //   elementtt.push(elementtt.push(res.data?.dataSets?.[1]));
            // }

            // console.log({ varrr0, varrr1, elementtt }, elementtt.length > 0);

            // if ((varrr0 || varrr1) && elementtt.length > 0) {
            //   setData({
            //     labels: res.data?.xaxixLabels,
            //     datasets: elementtt,
            //   });
            // } else {
            //   setData([]);
            // }

            let arrr = [];

            for (let index = 0; index < res.data?.dataSets?.length; index++) {
              let element = res.data?.dataSets?.[index];
              if (res.data.dataSets[index].label == "Success") {
                res.data.dataSets[index]["backgroundColor"] = "#3f9143";
                res.data.dataSets[index]["borderColor"] = "#3f9143";
                res.data.dataSets[index]["icon"] = ThumbUpIcon;
              }
              if (res.data.dataSets[index].label == "Failed") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f ";
                res.data.dataSets[index]["borderColor"] = "#f9442f ";
                res.data.dataSets[index]["icon"] = CancelIcon;
              }
              for (let i = 0; i < element?.data?.length; i++) {
                let element1 = element?.data?.[i];
                element["stack"] = `Stack ${index}`;

                if (element1 != null && element1 != 0) {
                  arrr.push(element);
                  break;
                }
              }
            }

            if (arrr?.length > 0) {
              setData({
                labels: res?.data?.xaxixLabels,
                datasets: arrr,
              });
            } else {
              setData([]);
            }

            setOpen(false);
          }
        } else {
          setData([]);
          setOpen(false);
        }
      } catch (error) {
        setData([]);
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  const options = {
    //   width: 839,
    // plugins: {
    //   title: {
    //     display: true,
    //     text: "User Management",
    //     legend: {
    //       position: "none",
    //       display: false,
    //     },
    //   },

    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (xDatapoint) => {
            if (isNaN(xDatapoint?.[0].label)) {
              return xDatapoint?.[0].label;
            } else {
              // console.log({ xDatapoint });
              // var dateObj = new Date();
              // var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
              // var year = dateObj.getUTCFullYear();

              // const newdate = xDatapoint?.[0].label + "/" + month1 + "/" + year;

              // return newdate;

              return data?.labelsName?.[xDatapoint?.[0]?.dataIndex];
            }
          },
          // label: (yDatapoint) => {
          //   console.log({ yDatapoint }); // All list shown in color
          //   return "22";
          // },
        },
      },
      datalabels: {
        display: true,
        color: "transparent",
        align: "center",
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          title: {
            font: {
              weight: "bold",
            },
          },
          value: {
            color: "transparent",
          },
        },
        formatter: function (value) {
          return "\n" + value;
        },
      },
    },

    onHover: (event, activeElements) => {
      // console.log({ activeElements });
      if (activeElements?.length > 0) {
        event.native.target.style.cursor = "pointer";
      } else {
        event.native.target.style.cursor = "auto";
      }
    },

    hover: {
      onHover: function (event, chartElement) {
        event.native.target.style.cursor = chartElement[0]
          ? "pointer"
          : "default";
        event.target.style.cursor = chartElement[0] ? "pointer" : "default";
      },
    },
    //   // zoom: {
    //   //   pan: {
    //   //     enabled: true,
    //   //     mode: "x",
    //   //   },
    //   //   // zoom: {
    //   //   //   limits: {
    //   //   //     y: { min: 0, max: 100 },
    //   //   //     y2: { min: -5, max: 5 },
    //   //   //   },
    //   //   //   wheel: {
    //   //   //     enabled: true,
    //   //   //   },
    //   //   //   pinch: {
    //   //   //     enabled: true,
    //   //   //   },

    //   //   //   mode: "x",
    //   //   // },
    //   //   rangeMin: {
    //   //     x: 2,
    //   //     y: 1,
    //   //   },
    //   //   rangeMax: {
    //   //     x: 10,
    //   //     y: 150,
    //   //   },
    //   // },
    // },
    legend: {
      display: false,
    },
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        maxTicksLimit: 11,
        title: {
          display: true,
          text: `<---- ${value === "Daily" ? "Date" : "Month"} ---->`,
          font: {
            family: "Poppins, sans-serif",
            size: 20,
            weight: "bolder",
            lineHeight: 1.2,
          },
        },
      },
      // y: {
      //   stacked: true,
      // },
      y: {
        ticks: {
          min: 0,
          max: 1,
          stepSize: 1,
          fontSize: 20,
        },
        title: {
          display: true,
          text: "<---- Count ---->",
          // color: "#911",
          font: {
            family: "Poppins, sans-serif",
            size: 20,
            weight: "bolder",
            lineHeight: 1.2,
          },
        },
      },
    },
  };

  // const options = {
  //   scales: {
  //     yAxes: [
  //       {
  //         ticks: {
  //           min: 0,
  //           max: 1,
  //           stepSize: 20,
  //           fontSize: 20,
  //         },
  //       },
  //     ],
  //     y: {
  //       ticks: {
  //         min: 0,
  //         max: 1,
  //         stepSize: 1,
  //         fontSize: 20,
  //       },
  //     },
  //   },
  //   // elements: {
  //   //   point: {
  //   //     radius: 0
  //   //   }
  //   // }
  // };

  useEffect(() => {
    assignUserApi();
  }, [resd?.timeSeries?.start, resd?.timeSeries?.end, value]);

  const printDatasetAtEvent = (dataset) => {
    if (!dataset.length) return;

    const datasetIndex = dataset[0].datasetIndex;

    // console.log(data.datasets[datasetIndex].label);

    return data.datasets[datasetIndex].label;
  };

  const printElementAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
    return data.labels[index];
  };

  const printElementIndexAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    return [index];
  };

  const printElementsAtEvent = (elements) => {
    if (!elements.length) return;

    // console.log(elements.length);
    return elements.length;
  };

  const handleClick = (event) => {
    // alert("Now clikced");

    // console.log(
    //   "IIIIIIII",
    //   printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),
    //   printElementAtEvent(getElementAtEvent(chartRef.current, event)),
    //   printElementIndexAtEvent(getElementAtEvent(chartRef.current, event)),
    //   !isNaN(
    //     data?.labelsNumber?.[
    //       printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
    //     ]
    //   )
    // );

    if (
      // !isNaN(printElementAtEvent(getElementAtEvent(chartRef.current, event)))
      !isNaN(
        data?.labelsNumber?.[
          printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
        ]
      )
    ) {
      var dateObj = new Date();
      var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
      var year = dateObj.getUTCFullYear();

      const newdate =
        year +
        "-" +
        month1 +
        "-" +
        printElementAtEvent(getElementAtEvent(chartRef.current, event));

      if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
        // localStorage?.setItem(
        //   "dstQueCode1",
        //   `${newdate},${printDatasetAtEvent(
        //     getDatasetAtEvent(chartRef.current, event)
        //   )},${value}`
        // );
        localStorage?.setItem(
          "dstQueCode1",
          `${
            data?.labelsName?.[
              printElementIndexAtEvent(
                getElementAtEvent(chartRef.current, event)
              )
            ]
          },${printDatasetAtEvent(
            getDatasetAtEvent(chartRef.current, event)
          )},${value}`
        );
      } else {
      }
    } else {
      // console.log(
      //   "PPPPPP",

      //   moment()
      //     .month(
      //       printElementAtEvent(getElementAtEvent(chartRef.current, event))
      //     )
      //     .format("M"),
      //   moment().format("M"),
      //   typeof moment().month("feb").format("M")
      // );

      if (
        Number(
          moment()
            .month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
            .format("M")
        ) <= Number(moment().format("M"))
      ) {
        const endDate = moment(
          moment().month(
            printElementAtEvent(getElementAtEvent(chartRef.current, event))
          )
        )
          .endOf("month")
          .format("YYYY-MM-DD");
        const startDate = moment(
          moment().month(
            printElementAtEvent(getElementAtEvent(chartRef.current, event))
          )
        )
          .startOf("month")
          .format("YYYY-MM-DD");
        localStorage?.setItem(
          "dstQueCode1",
          `${startDate},${printDatasetAtEvent(
            getDatasetAtEvent(chartRef.current, event)
          )},${value},${endDate}`
        );
      } else {
        const endDate = moment(
          moment(
            moment().month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
          ).endOf("month")
        )
          .add(-1, "y")
          .format("YYYY-MM-DD");
        const startDate = moment(
          moment(
            moment().month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
          ).startOf("month")
        )
          .add(-1, "y")
          .format("YYYY-MM-DD");

        localStorage?.setItem(
          "dstQueCode1",
          `${startDate},${printDatasetAtEvent(
            getDatasetAtEvent(chartRef.current, event)
          )},${value},${endDate}`
        );
      }
    }
    history?.push("/dashboard/Dashboardreport");
    // printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event));
    // printElementAtEvent(getElementAtEvent(chartRef.current, event));
    // printElementsAtEvent(getElementsAtEvent(chartRef.current, event));
  };

  // <div className="table-responsive">

  const handleButtonClick = (index) => {
    // console.log(chartRef.current.data.dataset);
    let dataaa = [...data?.datasets];
    dataaa[index].clicked = !dataaa[index].clicked;
    setData({
      ...data,
      datasets: dataaa,
    });
    chartRef.current.data.datasets[index].hidden =
      !chartRef.current.data.datasets[index].hidden;
    chartRef.current.update();
  };
  return (
    <>
      {!open && data ? (
        <>
          {data.length == 0 ? (
            <div className="d-flex h-100 p-3">
              <div className="m-auto text-center">
                <h1>No Data</h1>
                <img
                  style={{ width: "100px", maxWidth: "100%" }}
                  src={CancelImg}
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-center mt-2">
                {data?.datasets?.map((dataaa, index) => {
                  return (
                    <div>
                      {/* <button
                        className="btn btn-primary me-2"
                        style={{
                          backgroundColor: dataaa.backgroundColor,
                          textDecorationColor: "black",
                          textDecoration: chartRef?.current?.data?.datasets?.[
                            index
                          ]?.hidden
                            ? "line-through"
                            : "none",
                          color: "white",
                        }}
                        onClick={() => {
                          handleButtonClick(index);
                        }}
                      >
                        {dataaa?.label}
                      </button> */}
                      <Button
                        className="me-3"
                        size="small"
                        sx={{
                          borderRadius: 2,
                          boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                          backgroundColor: chartRef?.current?.data?.datasets?.[
                            index
                          ]?.hidden
                            ? "grey"
                            : dataaa.backgroundColor,
                          color: "white",
                          textDecorationColor: "black",
                          textDecoration: chartRef?.current?.data?.datasets?.[
                            index
                          ]?.hidden
                            ? "line-through"
                            : "none",
                          color: "white",
                        }}
                        variant="contained"
                        startIcon={
                          dataaa.icon ? <dataaa.icon /> : <ThumbUpIcon  />
                        }
                        onClick={() => {
                          handleButtonClick(index);
                        }}
                      >
                        {dataaa?.label}
                      </Button>


                    </div>
                  );
                })}
              </div>
              <Chart
                type="bar"
                ref={chartRef}
                options={options}
                data={data}
                onClick={handleClick}
                onHover={(event, chartElement) => {
                  event.target.style.cursor = chartElement[0]
                    ? "pointer"
                    : "default";
                }}
              />
            </>
          )}
        </>
      ) : (
        <>
          <Skeleton animation="wave" className="mt-3" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      )}
    </>
  );
  // </div>
}
